module.exports = __webpack_public_path__ + "static/chom-c45563a8a33189fc7d7e64e29269f412.jpg";